import c from './setting-menu-mobile.module.scss';
import { isStringEmpty } from '@monash/portal-frontend-common';
import {
  fontStyles,
  Icon,
  IconButton,
  Modal,
  ModalSection,
} from '@monash/portal-react';
import classNames from 'classnames';
import { useState } from 'react';

const SettingsMenuMobile = ({
  triggerRef,
  items,
  title,
  label,
  ...restProps
}) => {
  const [isMenuShown, setIsMenuShown] = useState(false);

  const openMenu = () => setIsMenuShown(true);
  const closeMenu = () => setIsMenuShown(false);

  const renderMenuItem = ({ item, index, isSubItem = false }) => {
    const itemHasPopup = !isStringEmpty(item.haspopup);

    return (
      <button
        key={index}
        type="button"
        className={classNames(c.menuListItem, fontStyles.body, {
          [c.subItem]: isSubItem,
        })}
        onClick={(event) => {
          item.function?.(event);
          closeMenu();
        }}
        style={{
          color: `var(${
            item.attention ? '--color-intent-attention' : '--card-text-color'
          })`,
        }}
        role="menuitem"
        aria-haspopup={itemHasPopup ? item.haspopup : null}
        data-tracking-event={item.trackingLabel}
      >
        {item.icon}
        {item.text}
      </button>
    );
  };

  return (
    <>
      <IconButton
        ref={triggerRef}
        icon={Icon.DotsHorizontal}
        mode="canvas"
        variant="text"
        onClick={openMenu}
        aria-haspopup="dialog"
        {...restProps}
      />
      <Modal
        open={isMenuShown}
        onClose={closeMenu}
        ariaLabel={title}
        ariaDescribedby={null}
      >
        <ModalSection
          title={title}
          noPadding
          ariaLabelledby={null}
          ariaDescribedby={null}
        >
          <ul className={c.menuList} role="menu">
            {items.map((item, i) => {
              return renderMenuItem({ item, index: i });
            })}
          </ul>
        </ModalSection>
      </Modal>
    </>
  );
};

export default SettingsMenuMobile;
